import { type FC } from "react";
import { TooltipWithIcon } from "@root/shared/components/TooltipWithIcon";

import * as styles from "./styles.css";

type Props = {
  normalScoutRemainingCount: string;
  nationalQualificationsNormalScoutRemainingCount: string;
  premiumScoutRemainingCount: string;
  resetDate: string;
};

export const PcScoutRemainingCountSummary: FC<Props> = ({
  normalScoutRemainingCount,
  nationalQualificationsNormalScoutRemainingCount,
  premiumScoutRemainingCount,
  resetDate,
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.headerRow}>
        <div className={styles.textAndTooltip}>
          スカウト残数：<span className={styles.boldText}>{normalScoutRemainingCount}</span>通
          <TooltipWithIcon
            arrowPosition="bottomRight"
            outerClassName={styles.tooltipOuter}
            tooltipZIndex="9999999"
          >
            <p className={`${styles.text} ${styles.tooltipWidth268}`}>
              気になる求職者に直接アプローチすることで、採用活動の効率を高めることができます。
              <br />
              受諾されたスカウトは、新着応募として応募一覧に表示されます。
            </p>
          </TooltipWithIcon>
        </div>
        <p className={styles.resetDate}>
          リセット日：{resetDate}
          <br />
          <span className={styles.resetDateNote}>(オプション購入分を除く)</span>
        </p>
      </div>
      <hr className={styles.hr} />
      <div className={styles.flexWrapper}>
        <div className={styles.item}>
          うちプレミアムスカウト：
          <br />
          <span className={styles.textAndTooltip}>
            <span className={styles.boldText}>{premiumScoutRemainingCount}</span>通
            <TooltipWithIcon
              arrowPosition="topCenter"
              outerClassName={styles.tooltipOuter}
              tooltipZIndex="9999999"
            >
              <p className={`${styles.text} ${styles.tooltipWidth280}`}>
                1通ごとにカスタマイズでき、求職者の経験やスキルに合わせて企業の魅力を伝えられるため、開封・応募に繋がりやすいスカウトです。
                <br />
                ※スカウト残数のうち20%をプレミアムスカウトとして利用可能です。
              </p>
            </TooltipWithIcon>
          </span>
        </div>
        <div className={styles.item}>
          うち国家資格職種希望者向け：
          <br />
          <span className={styles.boldText}>{nationalQualificationsNormalScoutRemainingCount}</span>
          通
        </div>
      </div>
    </div>
  );
};
